import { FC } from "react";
import { NotificationDTO } from "../../../../domain/models/dto/NotificationDTO";
import CancelIconSVG from "../../../resources/svg/CancelIconSVG";
import { NotificationType } from "../../../../domain/enums/NotificationTypeEnum";
import { useTranslation } from "react-i18next";
import { getNotificationCreatedTime } from "../../../../slices/notifications-slice";

interface ApplicationDeclinedCardProps {
    notification: NotificationDTO;
    onClick: () => void;
}

const ApplicationDeclinedCard: FC<ApplicationDeclinedCardProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div
            onClick={props.onClick}
            className="flex group cursor-pointer border-b border-b-textFaded pb-4 mb-3 dmax2:mb-2"
        >
            <div className="flex">
                <CancelIconSVG className="min-w-8 min-h-8 text-textFaded group-hover:text-textWhite transition duration-300 mr-3" />
                <div className="flex flex-col">
                    <div className="flex gap-[30px] dmax2:gap-[10px]">
                        <p className="H20 dmax2:H14B text-textWhite">
                            {t(`notifications.${NotificationType.APPLICATION_DECLINED}`)}
                        </p>
                        <div className="H16 dmax2:H14 text-textFaded text-nowrap">
                            {getNotificationCreatedTime(t, props.notification, true)}
                        </div>
                    </div>
                    <p className="H16B dmax2:H14 text-textWarning mt-[10px] dmax2:mt-1 [word-break:break-word]">
                        {props.notification.application?.work.title}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ApplicationDeclinedCard;
